import LocalizedStrings from 'react-localization';
import Moment from 'moment';
// import localeFr from 'moment/locale/fr.js';

import _ from 'lodash';
import { combineReducers } from 'redux';

import store from '../stores/store';
import { DEFAULT_LOCALE } from '../../locales';

import {
  SETTINGS_TOGGLE_SOUND,
  SETTINGS_THREADS_ORDERING,
  SETTINGS_SET_LOCALE,
  SETTINGS_ENTER_KEY
} from '../actions/settingsAction';


export default function (initialState={
  // ** SETTINGS **
  enterKey: 'off',
  sound: 'on', // 'on' || 'off'
  threadsOrdering: 'createdAt', // 'touchedAt' || 'createdAt'
  locale: DEFAULT_LOCALE
}, action) {

  switch (action.type) {
    case SETTINGS_ENTER_KEY: {
      return { ...initialState, enterKey: (store.getState().settings.enterKey === 'on' ? 'off' : 'on') }
    }

    case SETTINGS_TOGGLE_SOUND: {
      return { ...initialState, sound: (store.getState().settings.sound === 'on' ? 'off' : 'on') }
    }

    case SETTINGS_THREADS_ORDERING: {
      return { ...initialState, threadsOrdering: action.payload }
    }

    case SETTINGS_SET_LOCALE: {
      return { ...initialState, locale: action.locale };
    }
  }

  return initialState;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/settingsReducer.jsx